import { useNavigate } from "react-router-dom";
import classes from "./BottomMenu.module.css";

const BottomMenu = () => {
  const navigate = useNavigate();

  const onClickPrivacy = () => {
    navigate("/privacy");
  };

  const onClickTerms = () => {
    navigate("/terms");
  };

  return (
    <div className={classes.container}>
      <button className={classes.button} onClick={onClickPrivacy}>Privacy</button>
      <button className={classes.button} onClick={onClickTerms}>Terms Of Use</button>
    </div>
  );
};

export default BottomMenu;
